<template>
  <div class="success">
    <div class="container flexaj">
      <div style="width: 100px; height: 150px">
        <transition name="fade" enter-active-class="animated bounceInDown">
          <img
            v-show="isShow"
            src="@/assets/success.png"
            alt
            style="padding-bottom: 60px"
          />
        </transition>
      </div>
      <div class="detail flexc p-f16" v-loading="!isShow">
        <span class="p-f16 p-666">{{ getTitle }}</span>
        <div class="flexa">
          <span class="p-333" style="font-size: 24px"
            >訂單詳情已發送至登記電郵</span
          >
          <span
            class="p-f14"
            style="color: #a6aaba; margin-left: 8px"
            v-if="this.card_type === '01'"
            >(預計3個工作日回復)</span
          >
        </div>
        <span class="p-f16 p-333 p-fw" style="margin-top: 12px"
          >訂單編號：{{ order_no }}</span
        >
        <div class="flexc">
          <span class="p-f14" style="color: #a6aaba">{{ getDetail }}</span>
          <span class="p-f14" style="color: #a6aaba"
            >溫馨提示：申請註銷禮品卡，退回儲值額時需攜帶身份資料及出示參考編號.</span
          >
        </div>
        <el-button style="width: 120px; margin-top: 10px" @click="toHome"
          >返回首頁</el-button
        >
        <!-- <span class="p-f20 p-fw">訂單已提交,我們會馬上為您處理</span>
        <span>參考編號:{{order_no}}</span>
        <span class="p-999">溫馨提示: 申請註銷禮品卡、退回儲值額時需攜帶身份資料及出示參考編號</span>
        <span>若無特殊情況,預計一周內可收到產品.若有疑問,請撥打客服熱線或電郵聯繫.</span>-->
      </div>
    </div>
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { getUrlValue } from "@/utils/fun";
export default {
  data() {
    return {
      isShow: false,
      order_no: "",
      card_type: "",
      getTitle: "",
      getDetail: ""
    };
  },
  computed: {},
  methods: {
    toHome() {
      // window.location.href = `https://172.20.34.102/v4/`;
      window.location.href =
        process.env.NODE_ENV === "production"
          ? `https://www.globalcash.hk/v4`
          : process.env.NODE_ENV === "test"
          ? `https://172.20.34.102/v4/`
          : `https://172.20.34.222/v4/`;
      this.$router.push();
    },
    async getPrice() {
      let res = await aPost2(api.queryPrice, { order_no: this.order_no });
      if (res.data.errCode === "99999") {
        this.card_type = res.data.retData.card_type;
        this.isShow = true;
        this.getTitle =
          this.card_type === "01"
            ? "訂單已提交，請留意查收電郵及手機短信."
            : "訂單已提交，我們會馬上為您處理.";
        this.getDetail =
          this.card_type === "01"
            ? "若有疑問，請撥打客服熱線或電郵聯系"
            : "若無特殊情況，預計一周內可收到產品，若有疑問，請撥打客服熱線或電郵聯繫.";
      } else {
        this.$message.error(`${res.data.errMsg}`);
      }
    }
  },
  mounted() {
    if (getUrlValue("order_id")) {
      this.order_no = getUrlValue("order_id");
      this.getPrice();
    } else if (this.$route.params.order_no) {
      this.order_no = this.$route.params.order_no;
      this.getPrice();
    }
  }
};
</script>

<style lang="scss" scoped>
.success {
  font-family: "Microsoft YaHei", Arial, Helvetica, sans-serif;
  width: 960px;
  margin: 0 auto;
  .container {
    flex-grow: 1;
    padding: 120px 0 200px;
    .detail {
      margin-left: 40px;
    }
    .detail > span {
      margin-bottom: 10px;
    }
  }
}
</style>
